"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _syncPresenterAttendeeIds["default"];
  }
});
var _syncPresenterAttendeeIds = _interopRequireDefault(require("./syncPresenterAttendeeIds"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }